module.exports = __webpack_public_path__ + "static/media/Registro_de_Asistencia.3d8e6e67.docx";